import React, { useContext } from "react"
import { useTranslation } from "react-i18next"
import { DashboardContext } from "./DashboardContext"

export const StudentList = () => {
  const { t } = useTranslation()
  const { students, setSelectedStudentId, selectedStudentId } = useContext(DashboardContext)
  return (
    <div className="card-body">
      <p>{t("dashboard_information")}</p>
      {students?.map((student) => (
        <button
          className="tw-bg-blue-600 active:tw-bg- tw-text-white p-2 tw-rounded  md:tw-inline-block tw-block md:tw-w-auto tw-w-full m-2"
          key={student.id}
          style={selectedStudentId === student.id ? { backgroundColor: "#00388D" } : {}}
          onClick={() => setSelectedStudentId(student.id)}>
          {selectedStudentId === student.id && <i className="fa fa-check me-4"></i>}
          {student.name} {student.surname}
        </button>
      ))}
    </div>
  )
}
